<template>
  <baseFrame
    :infosArr='infosArr'
    :id='refundCode'
    :idText='idText'
  >
    <div slot="content">
      <lk-card title="上下查询单据">
        <charts :type="7" :id='this.$route.params.id+""' @handleClick='getChartInfo'></charts>
        <div class="tabs">
          <lk-tabs type='card' v-model="currentTab">
            <lk-tab-pane label="当前单据" v-if="currentSheet.length" name='0'>
              <chartTable :data='currentSheet' :type='currentType'></chartTable>
            </lk-tab-pane>
            <lk-tab-pane label="上查单据" v-if="lastSheet.length" name='1'>
              <chartTable :data='lastSheet' :type='lastType'></chartTable>
              <chartTable v-if="hasDoubleLast" :data='lastSheet2' :type='lastType2'></chartTable>
            </lk-tab-pane>
            <lk-tab-pane label="下查单据" v-if="nextSheet.length" name='2'>
              <chartTable :data='nextSheet' :type='nextType' class="mb16"></chartTable>
              <chartTable v-if="hasDoubleNext" :data='nextSheet2' :type='nextType2'></chartTable>
            </lk-tab-pane>
          </lk-tabs>
        </div>
      </lk-card>
    </div>
  </baseFrame>
</template>

<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import charts from '../../components/charts.vue';
import chartTable from '../../components/chartTable.vue';
import finance from '../../services/finance';
import refund from '../../services/refund';
import workflow from '../../services/workflow';
import utils from '../../libs/utils';

export default {
  name: 'refundSheet',
  components: {
    baseFrame,
    charts,
    chartTable,
  },
  data() {
    return {
      infosArr: [],
      currentTab: 0,
      refundCode: '',
      idText: '退货单号',
      currentSheet: [],
      lastSheet: [],
      lastSheet2: [],
      hasDoubleNext: false,
      hasDoubleLast: false,
      nextSheet: [],
      nextSheet2: [],
      currentType: 0,
      lastType: 0,
      lastType2: 0,
      nextType: 0,
      nextType2: 0,
      chartParams: {
        sourceType: 7, // 1采购计划 2采购订单 3收货单 4验收单 5应付单 6付款单 7退货单
        sourceId: this.$route.params.id, // 退货单号
      },
      payableColumns: [
        { title: '序号', type: 'index', minWidth: 116 },
        // { title: '单据来源', key: 'purchaseMedicineDrugSerialCode', minWidth: 116 },
        { title: '验收单号', key: 'purchaseInspectionInfoInspectionCode', minWidth: 116 },
        { title: '商品通用名称', key: 'purchaseMedicineApprovedDrugName', minWidth: 130 },
        { title: '规格', key: 'purchaseMedicineSpecification', minWidth: 116 },
        { title: '生产企业', key: 'purchaseMedicineManufacturer', minWidth: 116 },
        { title: '单价', key: 'purchaseInspectionInfoPriceBeforeTax', minWidth: 116 },
        { title: '数量', key: 'purchaseInspectionInfoPassNum', minWidth: 116 },
        {
          title: '税率',
          key: 'purchaseInspectionInfoTaxRate',
          minWidth: 116,
        },
        { title: '不含税单价', key: 'purchaseInspectionInfoPriceAfterTax', minWidth: 116 },
        { title: '单个税额', key: 'purchaseInspectionInfoTax', minWidth: 116 },
        { title: '含税总金额', key: 'purchaseInspectionInfoTotalPriceBeforeTax', minWidth: 116 },
        { title: '总税额', key: 'purchaseInspectionInfoTotalTax', minWidth: 116 },
      ],
      payableList: [],
      refundList: [],
      approvalStatusArr: ['草稿', '审批中', '审批通过', '审批未通过'],
    };
  },
  methods: {
    getChartInfo(val) {
      switch (val.data.type) {
        case 1:
          this.getPurchasePlan(val.data.value);
          break;
        case 2:
          this.getPurchaseOrder(val.data.value);
          break;
        case 3:
          this.getPurchaseReceipt(val.data.value);
          break;
        case 4:
          this.getInspection(val.data.value);
          break;
        case 5:
          this.getPayable(val.data.value);
          break;
        case 6:
          this.getPayment(val.data.value);
          break;
        case 7:
          this.getRefund(val.data.value);
          break;
        default:
          break;
      }
    },
    formatNode(data) {
      this.currentSheet = [];
      this.lastSheet = [];
      this.lastSheet2 = [];
      this.nextSheet = [];
      this.nextSheet2 = [];
      const {
        nextNode, nextNode2, lastNode, lastNode2, currentNode,
      } = data;
      if (nextNode) {
        this.nextType = nextNode.dataType;
        let tempNext = [];
        for (const key in nextNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(nextNode[key]) === '[object Object]') {
              tempNext.push(nextNode[key]);
            } else {
              tempNext = tempNext.concat(nextNode[key]);
            }
          }
        }
        tempNext.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.nextSheet.push(result);
        });
      }
      if (nextNode2) {
        this.hasDoubleNext = true;
        this.nextType2 = nextNode2.dataType;
        let tempNext = [];
        for (const key in nextNode2) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(nextNode2[key]) === '[object Object]') {
              tempNext.push(nextNode2[key]);
            } else {
              tempNext = tempNext.concat(nextNode2[key]);
            }
          }
        }
        tempNext.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.nextSheet2.push(result);
        });
      } else {
        this.hasDoubleNext = false;
      }
      if (lastNode) {
        this.lastType = lastNode.dataType;
        let tempLast = [];
        for (const key in lastNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(lastNode[key]) === '[object Object]') {
              tempLast.push(lastNode[key]);
            } else {
              tempLast = tempLast.concat(lastNode[key]);
            }
          }
        }

        tempLast.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (Object.prototype.toString.call(item[key]) === '[object Object]') {
              result = utils.deepClone(item[key]);
            } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
              if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                result.subList = [];
                const dataItem = item[key];
                dataItem.forEach((el) => {
                  const tempItem = {};
                  utils.exchangeTable(el, tempItem);
                  result.subList.push(tempItem);
                });
              }
            }
          }
          this.lastSheet.push(result);
        });
      }
      if (lastNode2) {
        this.hasDoubleLast = true;
        this.lastType2 = lastNode2.dataType;
        let tempLast = [];
        for (const key in lastNode2) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(lastNode2[key]) === '[object Object]') {
              tempLast.push(lastNode2[key]);
            } else {
              tempLast = tempLast.concat(lastNode2[key]);
            }
          }
        }
        tempLast.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (Object.prototype.toString.call(item[key]) === '[object Object]') {
              result = utils.deepClone(item[key]);
            } else if (Object.prototype.toString.call(item[key]) === '[object Array]' && item[key].length) {
              if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                result.subList = [];
                item[key].forEach((el) => {
                  const tempItem = {};
                  utils.exchangeTable(el, tempItem);
                  result.subList.push(tempItem);
                });
              }
            }
          }
          this.lastSheet2.push(result);
        });
      } else {
        this.hasDoubleLast = false;
      }
      if (currentNode) {
        this.currentType = currentNode.dataType;
        let tempCurrent = [];
        for (const key in currentNode) {
          if (key !== 'dataType') {
            if (Object.prototype.toString.call(currentNode[key]) === '[object Object]') {
              tempCurrent.push(currentNode[key]);
            } else {
              tempCurrent = tempCurrent.concat(currentNode[key]);
            }
          }
        }

        tempCurrent.forEach((item) => {
          let result = {};
          for (const key in item) {
            if (key !== 'dataType') {
              if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                result = utils.deepClone(item[key]);
              } else if (Object.prototype.toString.call(item[key]) === '[object Array]') {
                if (item[key].length > 0 && item[key][0].isFromSourceItem) {
                  result.subList = [];
                  item[key].forEach((el) => {
                    const tempItem = {};
                    utils.exchangeTable(el, tempItem);
                    result.subList.push(tempItem);
                  });
                }
              }
            }
          }
          this.currentSheet.push(result);
        });
      }
    },
    getPayable(id) {
      const params = utils.deepClone(this.chartParams);
      params.financePayableId = id;
      finance.flowInfoPayable(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPayment(id) {
      const params = utils.deepClone(this.chartParams);
      params.financePaymentId = id;
      finance.flowInfoPayment(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRefund(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseRefundId = id;
      refund.purchaseRefundChartLinkInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInspection(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseInspectionId = id;
      finance.flowInfoInspection(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchaseReceipt(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseReceiptId = id;
      finance.flowInfoPurchaseReceipt(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchaseOrder(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchaseOrderId = id;
      finance.flowInfoPurchaseOrder(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPurchasePlan(id) {
      const params = utils.deepClone(this.chartParams);
      params.purchasePlanId = id;
      finance.flowInfoPurchasePlan(params).then((res) => {
        if (res.data.status === 200) {
          this.formatNode(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDetails() {
      return new Promise((resolve) => {
        refund.purchaseRefundInfo({ purchaseRefundId: this.$route.params.id }).then((res) => {
          if (res.data.status === 200) {
            const purchaseRefund = res.data.data.purchaseRefund;
            this.refundCode = purchaseRefund.code;
            this.infosArr[0] = {
              name: '门店名称:',
              value: purchaseRefund.storeName,
            };
            this.infosArr[1] = {
              name: '创建时间:',
              value: utils.exchangeTimeToSecond(purchaseRefund.createTime),
            };
            this.infosArr[2] = {
              name: '创建人:',
              value: purchaseRefund.createUserName,
            };
            // this.infosArr[3] = {
            //   name: '单据状态:',
            //   value: this.approvalStatusArr[purchaseRefund.status - 1],
            // };
            // this.infosArr[4] = {
            //   name: '审核人:',
            //   value: '',
            // };
            this.workCode = purchaseRefund.workCode;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getApprovalUserName(workNo) {
      if (!workNo) {
        return;
      }
      workflow.approveSteps({ workNo }).then((res) => {
        if (res.data.status === 200) {
          const nodeList = res.data.data.nodeVoList;
          const time = nodeList[nodeList.length - 2].time;
          const userName = nodeList[nodeList.length - 2].userName;
          if (time) {
            this.infosArr.push({
              name: '审核时间:',
              value: utils.exchangeTimeToSecond(time),
            });
          }
          if (userName) {
            this.infosArr.push({
              name: '审核人:',
              value: userName,
            });
          }
        }
      });
    },
  },
  created() {
    this.getDetails().then(() => {
      this.getChartInfo({ data: { type: 7, value: this.$route.params.id } });
      this.getApprovalUserName(this.workCode); // 获取审批人
    });
  },
};
</script>
<style lang="less" scoped>

</style>
